"use strict";
/**
 * @description 引用
 * @author tonghan
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dom_core_1 = __importDefault(require("../../utils/dom-core"));
var util_1 = require("../../utils/util");
var BtnMenu_1 = __importDefault(require("../menu-constructors/BtnMenu"));
var Quote = /** @class */ (function (_super) {
    __extends(Quote, _super);
    function Quote(editor) {
        var _this = this;
        var $elem = dom_core_1.default("<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-quotes-left\"></i>\n            </div>");
        _this = _super.call(this, $elem, editor) || this;
        return _this;
    }
    /**
     * 点击事件
     */
    Quote.prototype.clickHandler = function () {
        var editor = this.editor;
        var isSelectEmpty = editor.selection.isSelectionEmpty();
        var $topNodeElem = editor.selection.getSelectionRangeTopNodes(editor)[0];
        var nodeName = this.getTopNodeName();
        if (isSelectEmpty) {
            // 选区范围是空的，插入并选中一个“空白”
            editor.selection.createEmptyRange();
        }
        if (util_1.UA.isIE() || util_1.UA.isFirefox || util_1.UA.isOldEdge) {
            // IE 中不支持 formatBlock <BLOCKQUOTE> ，要用其他方式兼容
            // 兼容firefox无法取消blockquote的问题
            var nodeList = $topNodeElem.getNode().childNodes;
            if (nodeName === 'P') {
                // 将 P 转换为 quote
                var $targetELem = dom_core_1.default("<blockquote></blockquote>");
                var targetElem = $targetELem.getNode();
                this.insertNode(targetElem, nodeList);
                $targetELem.insertAfter($topNodeElem);
                $topNodeElem.remove();
                editor.selection.moveCursor($targetELem.getNode());
                // 防止最后一行无法跳出
                dom_core_1.default("<p><br></p>").insertAfter($targetELem);
                return;
            }
            if (nodeName === 'BLOCKQUOTE') {
                // 撤销 quote
                var $targetELem = dom_core_1.default("<p></p>");
                var targetElem = $targetELem.getNode();
                this.insertNode(targetElem, nodeList);
                $targetELem.insertAfter($topNodeElem);
                $topNodeElem.remove();
                editor.selection.moveCursor($targetELem.elems[0]);
            }
        }
        else {
            // 执行 formatBlock 命令
            if (nodeName === 'BLOCKQUOTE') {
                editor.cmd.do('formatBlock', '<p>');
            }
            else {
                editor.cmd.do('formatBlock', '<blockquote>');
            }
        }
        if (isSelectEmpty) {
            // 需要将选区范围折叠起来
            editor.selection.collapseRange();
            editor.selection.restoreSelection();
        }
    };
    /**
     * 尝试修改菜单激活状态
     */
    Quote.prototype.tryChangeActive = function () {
        var editor = this.editor;
        var cmdValue = editor.cmd.queryCommandValue('formatBlock');
        if (cmdValue === 'blockquote') {
            this.active();
        }
        else {
            this.unActive();
        }
    };
    /**
     * 获取包裹在最外层的节点(防止内部嵌入多个样式)
     * @param selectionElem 选中的节点
     * @returns {string} 最终要处理的节点名称
     */
    Quote.prototype.getTopNodeName = function () {
        var editor = this.editor;
        var $topNodeElem = editor.selection.getSelectionRangeTopNodes(editor)[0];
        var nodeName = $topNodeElem.getNodeName();
        return nodeName;
    };
    /**
     * 将nodelist插入element中，并做一些特殊化处理
     * @param element 需要插入的父节点
     * @param nodeList 需要插入的nodelist
     */
    Quote.prototype.insertNode = function (element, nodeList) {
        nodeList.forEach(function (node, i) {
            // 去除空节点
            if (node.nodeName && node.textContent !== null) {
                if (node.nodeName !== 'BR' || i !== nodeList.length - 1) {
                    // 去除最后的br
                    element.appendChild(node.cloneNode(true));
                }
            }
        });
    };
    return Quote;
}(BtnMenu_1.default));
exports.default = Quote;
